export default {
  'address.TheShippingAddressCannotBeEmpty': 'The shipping address cannot be empty!',
  'address.NameIsNotLegal': 'Name is not legal',
  'address.EnterTheMobilePhoneNumberAreaCode': 'Enter the mobile phone number area code',
  'address.EnterTheCorrectPhoneNumber': 'Enter the correct phone number',
  'address.PleaseSelectARegion': 'Please select a region',
  'address.AddressesCannotContainIllegalCharacters': 'Addresses cannot contain illegal characters',
  'address.PleaseEnterTheCertificateNumberCorrectly':
    'Please enter the certificate number correctly',
  'address.MyAddressPageDefaultAddressSwitch': 'My Address Page_Default Address Switch',
  'address.MyAddressPageSaveAndUse': 'My Address page_Save and use',
  'address.TheOperationFailed': 'The operation failed',
  'address.OperationSuccessful': 'Operation successful!',
  'address.ParameterError': 'Parameter error',
  'address.MyAddressPageDeleteAddress': 'My Address page_Delete Address',
  'address.DeleteFailed': 'Delete failed',
  'address.PleaseEnterTheConsigneeName': "Recipient's Name",
  'address.TheNameOfTheConsigneeShallNotExceed20Characters':
    'The name of the consignee shall not exceed 20 characters',
  'address.TheNameOfTheConsignee': "Recipient's Name",
  'address.name': 'name',
  'address.PleaseEnterYourPhoneNumber': 'Please Enter Your Mobile Phone Number',
  'address.ContactNumber': 'Contact Phone Number',
  'address.SelectAStateOrMunicipality': 'Select Province, City or Autonomous Region',
  'address.Region': 'Location',
  'address.TheTypeOfCredential': 'The type of credential',
  'address.PleaseEnterTheIdNumber': 'Please enter the id number',
  'address.DetailedAddress': 'Detailed address',
  'address.SuchAsTheCommunityBuildingNumberHouseNumberEtc':
    'Such as community name, building number, door number, etc...',
  'address.PleaseEnterYourFullAddress': 'Please enter your full address',
  'address.StreetDoorNumbersDoNotExceed100Words': 'Street door numbers do not exceed 100 words',
  'address.SetToTheDefaultAddress': 'Set as default address',
  'address.SetToDefaultAddressNextTimeAfterDefaultingToUseTheAddress':
    'After setting as the default address, it will be used by default next time',
  'address.DeleteAnAddress': 'Delete an address',
  'address.SaveAndUse': 'Save and use'
};
